import { Button, Select, Text } from '../../common/designs'
import { ComputerWithTeam, formatBarDate } from './computerDetailsUtils'

interface Props {
  title: string
  activeDate: string
  connectedCount: number
  expectedCount: number | null
  availableDates: string[]
  diffWithDate: string
  onDiffWithDateChange: (date: string) => void
  notConnectedComputers: ComputerWithTeam[]
  isLoading: boolean
  position: { x: number; y: number }
  onMouseEnter: () => void
  onMouseLeave: () => void
  onViewAllClick: () => void
}

const ConnectedComputersPopover = ({
  title,
  activeDate,
  connectedCount,
  expectedCount,
  availableDates,
  diffWithDate,
  onDiffWithDateChange,
  notConnectedComputers,
  isLoading,
  position,
  onMouseEnter,
  onMouseLeave,
  onViewAllClick,
}: Props) => (
  <div
    className='absolute z-30 w-80 rounded-xl border border-gray-200 bg-white p-4 shadow-xl'
    style={{ left: Math.max(8, position.x - 160), top: Math.max(8, position.y - 300) }}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    <Text size='xs' color='lightGray'>
      {title}
    </Text>
    <Text size='l' weight={700}>
      {formatBarDate(activeDate)}
    </Text>

    <div className='my-3 grid grid-cols-2 gap-3'>
      <div className='rounded-lg bg-gray-50 p-2.5'>
        <Text size='xl' weight={700}>
          {connectedCount}
        </Text>
        <Text size='xs' color='lightGray'>
          Connected
        </Text>
      </div>
      <div className='rounded-lg bg-gray-50 p-2.5'>
        <Text size='xl' weight={700}>
          {expectedCount ?? '-'}
        </Text>
        <Text size='xs' color='lightGray'>
          Expected
        </Text>
      </div>
    </div>

    <div className='flex items-center gap-2'>
      <Text size='xs'>Diff with date:</Text>
      <Select
        size='xs'
        className='min-w-36 flex-1'
        value={diffWithDate}
        options={availableDates.map((date) => ({ label: formatBarDate(date), value: date }))}
        onChange={(value: string | number | null) => onDiffWithDateChange(String(value))}
      />
    </div>

    <Text size='xs' color='lightGray' weight={600} className='mb-1.5 mt-3'>
      Not connected computers
    </Text>
    {isLoading ? (
      <Text size='xs' color='lightGray'>
        Loading computers...
      </Text>
    ) : (
      notConnectedComputers.slice(0, 10).map((computer, index) => (
        <div
          key={`${computer.teamId}-${computer.ipAddress}-${computer.computerName}-${index}`}
          className='flex justify-between border-b border-gray-100 py-1 text-xs last:border-0'
        >
          <span className='font-semibold text-gray-800'>{computer.computerName}</span>
          <span className='font-mono text-gray-400'>{computer.ipAddress}</span>
        </div>
      ))
    )}
    {notConnectedComputers.length > 10 && (
      <Text size='xs' color='lightGray' className='mt-1'>
        + {notConnectedComputers.length - 10} more
      </Text>
    )}

    <Button size='s' wFull className='mt-3' onClick={onViewAllClick}>
      View all the {connectedCount} connected computers →
    </Button>
  </div>
)

export default ConnectedComputersPopover
